"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _horizontalRuleModule = _interopRequireDefault(require("./horizontalRule.module.css"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapVariantToClassName = function mapVariantToClassName(variant) {
  if (variant === "pale") {
    return _horizontalRuleModule.default["hr-pale"];
  }

  if (variant === "dotted") {
    return _horizontalRuleModule.default["hr-dotted"];
  }

  return _horizontalRuleModule.default["hr-dotted"];
};

var HorizontalRule = function HorizontalRule(props) {
  var id = props.id,
      variant = props.variant,
      _props$hrTestId = props.hrTestId,
      hrTestId = _props$hrTestId === void 0 ? 'horizontal-rule' : _props$hrTestId;
  var mappedClassName = mapVariantToClassName(variant);
  return _react.default.createElement("hr", {
    id: id ? id : null,
    className: mappedClassName,
    "data-testid": hrTestId
  });
};

HorizontalRule.propTypes = {
  /** String text that specifies a unique id for an HTML element. Consistent Id type: snake_case*/
  id: _propTypes.default.string,

  /** Variant. Default dotted */
  variant: _propTypes.default.oneOf(["dotted", "pale"]),

  /** Test ID for horizontal rule*/
  hrTestId: _propTypes.default.string
};
var _default = HorizontalRule;
exports.default = _default;